import React from 'react'
import EasingTick from './shapes/easing-tick'
import colors from './colors'
import uniq from 'lodash/uniq'

import { FONT_SMALL, PADDING, HORIZONTAL_TICK_HEIGHT } from './constants'

class SecondaryXAxis extends React.PureComponent {
  static defaultProps = {
    primary: 'primary',
    secondary: 'shortName',
    stroke: colors.defaultGray,
    data: [],
    x: 0,
    y: 0,
    fontSize: FONT_SMALL,
    height: HORIZONTAL_TICK_HEIGHT,
    padding: PADDING
  }

  displayTitle() {
    const { data, secondary, multi } = this.props

    return multi || uniq(data.map(i => i[secondary])).length <= 1
  }

  render() {
    const {
      data,
      fontSize,
      scale,
      x,
      y,
      height,
      title,
      primary,
      secondary,
      stroke,
      padding
    } = this.props

    const [left, right] = scale.range()
    const width = right - left

    let ticks = null

    if (this.displayTitle()) {
      ticks = (
        <EasingTick
          label={title.toUpperCase()}
          fontSize={fontSize}
          x={left}
          height={height + padding}
          width={width}
          fill={stroke}
        />
      )
    } else {
      ticks = data.map(function(item, i) {
        const label = item[secondary].toUpperCase()
        const xOffset = scale(item[primary])

        return (
          <EasingTick
            key={i}
            label={label}
            fontSize={fontSize}
            x={xOffset}
            height={height + padding}
            width={scale.bandwidth()}
            fill={stroke}
          />
        )
      }, this)
    }

    return (
      <g transform={`translate(${x},${y})`}>
        <line
          className="axis__meter"
          x1={left}
          x2={right}
          stroke={stroke}
          strokeWidth="2"
        />
        {ticks}
      </g>
    )
  }
}

export default SecondaryXAxis



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/secondary-x-axis.js